import { LoadingSpinner } from "components/LoadingSpinner";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetPayerByIdQuery } from "store/queries/payers";

import { Aliases } from "./components/Aliases";
import { GroupNumbers } from "./components/GroupNumbers";
import { Header } from "./components/Header";
import { MedtelIds } from "./components/MedtelIds";
import { MemberIdPrefixes } from "./components/MemberIdPrefixes";
import { Parent } from "./components/Parent";
import { PayerName } from "./components/PayerName";
import { PverifyId } from "./components/PverifyId";
import { SecondaryAbsorbsFullResponsibility } from "./components/SecondaryAbsorbsFullResponsibility";
import { SubmitEditPayer } from "./components/SubmitEditPayer";

export function EditPayerPage() {
  useDocumentTitle("Edit Payer");
  const { id } = useParams();
  const { data: payer, isLoading } = useGetPayerByIdQuery(id);
  const methods = useForm({
    defaultValues: {
      name: payer?.data.name,
      type: payer?.data.type,
      parent: payer?.data.parent,
      pverifyId: payer?.data.pverifyId,
      medtelIds: payer?.data.medtelIds,
      aliases: payer?.data.aliases,
      memberIdPrefixes: payer?.data.memberIdPrefixes,
      groupNumbers: payer?.data.groupNumbers,
      groupNumberMode: payer?.data.groupNumberMode ?? "INCLUDE",
      secondaryAbsorbsFullResponsibility:
        payer?.data.secondaryAbsorbsFullResponsibility ?? false,
    },
  });

  useEffect(() => {
    if (payer) {
      methods.reset({
        name: payer?.data.name,
        type: payer?.data.type,
        parent: payer?.data.parent,
        pverifyId: payer?.data.pverifyId,
        medtelIds: payer?.data.medtelIds,
        aliases: payer?.data.aliases,
        memberIdPrefixes: payer?.data.memberIdPrefixes,
        groupNumbers: payer?.data.groupNumbers,
        groupNumberMode: payer?.data.groupNumberMode ?? "INCLUDE",
        secondaryAbsorbsFullResponsibility:
          payer?.data.secondaryAbsorbsFullResponsibility ?? false,
      });
    }
  }, [payer, methods]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <FormProvider {...methods}>
      <Header isPayer isEditing name={payer?.data.name} />
      <PayerName />
      <Parent />
      <PverifyId />
      <MedtelIds />
      <Aliases />
      <MemberIdPrefixes />
      <GroupNumbers />
      <SecondaryAbsorbsFullResponsibility />
      {/*
        CLE-2792 review round 1 — LINE TYPE DEFINITIONS ARE NOT EDITED HERE. They were, briefly, and
        the payer page could only ever show that payer's half of the effective set: the every-payer
        definitions that also apply were on another screen. They live in Eligibility › Line Type Definitions,
        which lists both layers in one table with a Payer column.
      */}
      {id && payer && <SubmitEditPayer id={id} />}
    </FormProvider>
  );
}
